import React from 'react';
import './AnimalWelfare.css';

const AnimalWelfare = () => {
  return (
    <section id="welfare" className="welfare-section">
      <div className="welfare-image-wrapper-full">
        <img 
          src="/images/animal-welfare.png" 
          alt="Animal Welfare Initiative" 
          className="welfare-full-image" 
          loading="lazy"
          decoding="async"
        />
      </div>
    </section>
  );
};

export default AnimalWelfare;
